// react
import { ReactElement } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";
// redux
import { useAppDispatch } from "../../../../redux/hooks";
// kendo
import { GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
// redux
import { itemFileDownloaded, itemInfoDownloaded } from "../../nopimsBasketSlice";
// common
import CustomGridCell from "../../../../common/kendoGrid/CustomGridCell";
import ExternalLinkView from "../../../../common/externalLink/ExternalLinkView";
import * as GlobalHelpers from "../../../../common/GlobalHelpers";

export default function BasketItemGridColumnsView(): Array<ReactElement<GridColumnProps>> {
    const dispatch = useAppDispatch();

    return [
        <GridColumn
            key="infoUrl"
            field="infoUrl"
            title="Info"
            width={110}
            cell={(props) => (
                <CustomGridCell gridCellProps={props}>
                    {props.dataItem.infoUrl && (
                        <ExternalLinkView
                            href={props.dataItem.infoUrl}
                            onClick={() => {
                                dispatch(itemInfoDownloaded(props.dataItem));
                            }}
                            onContextMenu={(e) => {
                                e.preventDefault();
                            }}
                        >
                            Listing
                        </ExternalLinkView>
                    )}
                    {props.dataItem.isInfoDownloaded && <AiOutlineCloudDownload className="ms-2" size={18} color="blue" title="This file has been downloaded." />}
                </CustomGridCell>
            )}
        />,
        <GridColumn
            key="downloadUrl"
            field="downloadUrl"
            title="Download"
            width={170}
            cell={(props) => (
                <CustomGridCell gridCellProps={props}>
                    {props.dataItem.downloadUrl && (
                        <ExternalLinkView
                            href={props.dataItem.downloadUrl}
                            onClick={() => {
                                dispatch(itemFileDownloaded(props.dataItem));
                            }}
                            onContextMenu={(e) => {
                                e.preventDefault();
                            }}
                        >
                            {props.dataItem.downloadName}
                        </ExternalLinkView>
                    )}
                    {props.dataItem.isFileDownloaded && <AiOutlineCloudDownload className="ms-2" size={18} color="blue" title="This file has been downloaded." />}
                </CustomGridCell>
            )}
        />,
        <GridColumn
            key="fileSizeBytes"
            field="fileSizeBytes"
            title="File Size"
            width={140}
            cell={(props) => <CustomGridCell gridCellProps={props}>{props.dataItem.fileSizeBytes && GlobalHelpers.convertBytesToString(props.dataItem.fileSizeBytes)}</CustomGridCell>}
        />,
        <GridColumn key="itemId" field="itemId" title="Item ID" width={200} />,
        <GridColumn key="dataDescription" field="dataDescription" title="Data Description" width={400} />,
        <GridColumn key="documentType" field="documentType" title="Document Type" width={160} />,
        <GridColumn key="type" field="type" title="Report/Data Type" width={200} />,
        <GridColumn key="activity" field="activity" title="Activity Type" width={110} />,
        <GridColumn key="activityIdentifier" field="activityIdentifier" title="Activity ID" width={130} />,
        <GridColumn key="activityName" field="activityName" title="Activity Name" width={300} />,
    ];
}
